import type { CreateKnowledgeBaseInput } from "../entities/knowledge-base"
import type { KnowledgeBaseRepository } from "../repositories/knowledge-base-repository"

export const makeCreateKnowledgeBase = (repo: KnowledgeBaseRepository) =>
  (input: CreateKnowledgeBaseInput) =>
    repo.create(input)
